<template>
<div class="row">
    <div class="col-md-6 col-12 pr-0 cont-province">
        <div class="form-group">
            <div 
                v-if="showlabels" 
                class="row no-gutters" 
                id="label-province"
            >
                <div class="col-12">
                    <label 
                        class="font-weight-bold mr-2"
                        v-text="labelprovince"></label>
                </div>
            </div>
            <voucher-partecipant-province
                ref="provincecomponent"
                @province-selected="onProvinceSelected"
                @province-changed="onProvinceChanged"
                v-model="cprovince" 
                :class="classprovince"
            ></voucher-partecipant-province>

            <span 
                v-if="haserrprovince" 
                v-text="errmsgprovince"
                class="invalid-feedback animated fadeIn"
            ></span>
        </div>
    </div>
    <div class="col-md-6 col-12 pl-0 pl-md-3 pr-0 cont-municipality">
        <div class="form-group">
            <div 
                v-if="showlabels" 
                class="row no-gutters" 
                id="label-municipality"
            >
                <div class="col-12">
                    <label 
                        class="font-weight-bold mr-2"
                        v-text="labelmunicipality"></label>
                </div>
            </div>
            <voucher-partecipant-municipality
                ref="municipalitycomponent"
                @municipality-changed="onMunicipalityChanged"
                :province="selectedProvinceId"
                v-model="cmunicipality" 
                :class="classmunicipality"
            ></voucher-partecipant-municipality>
            
            <span 
                v-if="haserrmunicipality" 
                class="invalid-feedback animated fadeIn"
                v-text="errmsgmunicipality"></span>
        </div>
    </div>
</div>
</template>
  
<script>
import VoucherPartecipantProvince from './VoucherPartecipantProvince'
import VoucherPartecipantMunicipality from './VoucherPartecipantMunicipality'

export default {
    props: ['cname', 'objprovince', 'objmunicipality', 'formerrors', 'errkeyprovince', 'errkeymunicipality', 'selectedprovince', 'showlabels', 'labelprovince', 'labelmunicipality'],
    components: {
        VoucherPartecipantProvince,
        VoucherPartecipantMunicipality
    },
    data() {
        return {
          componentName: this.cname || 'provincemunicipality',
          selectedProvinceId: this.selectedProvince,
        }
    },
    computed: {
        haserrprovince: {
            cache: false,
            get() {
                    if(this.formerrors) {
                    return this.formerrors.has(this.errkeyprovince)
                }

                return false
            }
        },
        haserrmunicipality: {
            cache: false,
            get() {
                if(this.formerrors) {
                    return this.formerrors.has(this.errkeymunicipality)
                }
                
                return false
            }
        },
        errmsgprovince: {
            cache: false,
            get() {
                if(this.formerrors) {
                    return this.formerrors.get(this.errkeyprovince)
                }
            
                return ''
            }
        },
        errmsgmunicipality: {
            cache: false,
            get() {
                if(this.formerrors) {
                    return this.formerrors.get(this.errkeymunicipality)
                }

                return ''
            }
        },
        classprovince: {
            cache: false,
            get() {
                if(this.formerrors) {
                    return {'is-invalid': this.haserrprovince}
                }

                return ''
            }
        },
        classmunicipality: {
            cache: false,
            get() {
                if(this.formerrors) {
                    return {'is-invalid': this.haserrmunicipality}
                }

                return ''
            }
        },
        cprovince: {
            cache: false,
            get() {
                let province = ''

                if(this.objprovince) {
                    if(this.objprovince["long_name"]) {
                        province = this.objprovince["long_name"]
                    } else {
                        province = this.objprovince
                    }
                }

                // console.log(this.objprovince)
                // console.log(province)

                return province
            }
        },
        cmunicipality: {
            cache: false,
            get() {
                let municipality = ''

                if(this.objmunicipality) {
                    if(this.objmunicipality["name"]) {
                        municipality = this.objmunicipality["name"]
                    } else {
                        municipality = this.objmunicipality
                    }
                }

                // console.log(this.objmunicipality)
                // console.log(municipality)

                return municipality
            }
        }
    },
    methods: {
        onProvinceSelected(province) {
            this.selectedProvinceId = province
        },
        onProvinceChanged({
            province, 
            component
        }) {
            this.province = province
            
            this.$emit('geo-changed', {
                key: component,
                value: this.province,
                component: this.componentName
            })
        },
        onMunicipalityChanged({
            municipality,
            component
        }) { 
            this.municipality = municipality

            this.$emit('geo-changed', {
                key: component,
                value: this.municipality,
                component: this.componentName
            })
        },
        getProvinceComponent() {
            return this.$refs.provincecomponent
        },
        getMunicipalityComponent() {
            return this.$refs.municipalitycomponent
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/ProvinceMunicipality.vue